<template>
  <div class="application-component"
       v-if="formDescriptors.length">
    <!-- Title -->
    <div class="columns">
      <div class="column is-12">
        <title-component
          class="is-uppercase"
          :size="layout.title_size"
          :lineSeparator="layout.title_line_separator">
          {{ title }}
        </title-component>
        <!-- Description -->
        <div class="subtitle is-6">{{ description }}</div>
      </div>
    </div>

    <!-- Forms -->
    <template v-if="formDescriptors && formDatas">
      <form-component
        v-for="formDescriptor in formDescriptors"
        :formDescriptor="formDescriptor"
        :formData="getFormDataForDescriptor(formDescriptor)"
        :key="formDescriptor.id">
      </form-component>
    </template>

    <!-- Buttons -->
    <div class="field is-grouped">
      <p class="control">
        <submit-btn-component ref="enterButton" class="is-primary is-large is-uppercase" @submit="saveApplication" :group="'btnGroup'" v-translate>Send in application</submit-btn-component>
      </p>
      <p class="control">
        <submit-btn-component class="button is-danger is-outlined is-large" @submit="$router.push({ name: 'ApplyForServiceView' })" :group="'btnGroup'" v-translate>
          Cancel
        </submit-btn-component>
      </p>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import TitleComponent from '@/components/layout/TitleComponent'
  import FormComponent from '@/components/form/FormComponent'
  import { onKeyEnterMixin, formHandlerMixin, setContainedHeightMixin } from '@/mixins/mixins'
  import SubmitBtnComponent from '@/components/layout/utility/SubmitBtnComponent.vue'

  let VueScrollTo = require('vue-scrollto')

  export default {
    name: 'application-component',
    mixins: [onKeyEnterMixin, formHandlerMixin, setContainedHeightMixin],
    directives: {
      VueScrollTo
    },
    data () {
      return {
        submitRequest: null
      }
    },
    props: {
      code: {
        required: true
      }
    },
    components: {
      FormComponent,
      TitleComponent,
      SubmitBtnComponent
    },
    computed: {
      ...mapState({
        title: state => state.formModule.title,
        description: state => state.formModule.description,
        layout: state => state.formModule.layout,
        formDescriptors: state => state.formModule.formDescriptors,
        formDatas: state => state.formModule.formDatas,
        service: state => state.formModule.service
      })
    },
    methods: {
      ...mapActions([
        'setupApplicationFormAsCustomer',
        'saveApplicationFormAsCustomer',
        'clearData',
        'successMessage'
      ]),
      saveApplication (btn) {
        let requestData = {
          formDatas: this.formDatas,
          service: this.service
        }
        this.submitRequest = this.saveApplicationFormAsCustomer
        this.submitForm(requestData, btn, this.saveApplicationCallback)
        // btn.enable()
        // this.saveApplicationCallback()
      },
      saveApplicationCallback () {
        this.successMessage(this.$ngettext('Application sent'))
        this.$router.push({ name: 'DashboardView' })
      }
    },
    created () {
      this.setupApplicationFormAsCustomer(this.code).then(() => {
        this.setContainedHeight()
      }).catch((err) => {
        this.handleError(err)
      })
    },
    beforeDestroy () {
      this.clearData()
    }
  }
</script>

<style lang="sass" scoped>
  .title
    margin-bottom: 0.4rem
</style>
